import React from 'react';

import { Paragraph } from '../components/Paragraph';
import { Subtitle } from '../components/Subtitle';

export const RetentionOfPersonalData = () => {
  return (
    <>
      <Subtitle>Retention of Personal Data</Subtitle>
      <Paragraph>
        Once Glints has obtained your personal information and/or data, it will
        be maintained securely in Glints’ system for the period necessary to
        fulfill the purposes for which the data was collected as set out under
        the section headed “Purpose of Collection of Personal Data”. Once
        registered, you may terminate your membership of the Site by contacting
        Glints using the contact details under the section headed “Enquiries”.
        Glints may retain your personal information even after you have closed
        your account if retention is reasonably necessary to comply with our
        legal obligations, meet regulatory requirements, resolve disputes
        between Users, prevent fraud and abuse, or enforce this Privacy
        Statement and the Terms and Conditions.
      </Paragraph>
    </>
  );
};
